export default __webpack_public_path__ + "static/media/home-decor-img-08.78989ffd.png";